import { createSlice } from '@reduxjs/toolkit';
import { SearchStatus } from '../../constants';

const initialState = {
  customers: null,
  customerByCustomerId: {},
  searchCustomerByEmailStatuses: {},
  searchCustomerByEmailError: undefined,
  getSavedCardsStatuses: {},
  deleteCardStatus: {},
  savedCardsByCustomerId: {},
  setDefaultCardStatus: {},
  searchCustomersStatus: SearchStatus.INITIAL,
  searchCustomersError: undefined,
};

const customerSlice = createSlice({
  name: 'scroll',
  initialState,
  reducers: {
    setSelectedCustomer: (state, { payload }) => ({
      ...state,
      ...payload,
    }),
    searchCustomersRequest: (state) => ({
      ...state,
      searchCustomersError: null,
      searchCustomersStatus: SearchStatus.SEARCHING,
    }),
    searchCustomersSuccess: (state, { payload: { error, customers } }) => ({
      ...state,
      searchCustomersError: error,
      searchCustomersStatus: SearchStatus.DONE,
      customers,
    }),

    searchCustomerByEmailRequest: (state, { payload: { customerEmail } }) => ({
      ...state,
      searchCustomerByEmailError: null,
      searchCustomerByEmailStatuses: {
        ...state.searchCustomerByEmailStatuses,
        [customerEmail.toLowerCase()]: SearchStatus.SEARCHING,
      },
    }),
    searchCustomerByEmailResponse: (state, { payload: { error, customer, customerEmail } }) => ({
      ...state,
      searchCustomerByEmailError: error,
      searchCustomerByEmailStatuses: {
        ...state.searchCustomerByEmailStatuses,
        [customerEmail.toLowerCase()]: SearchStatus.DONE,
      },
      customerByCustomerId: !customer
        ? state.customerByCustomerId
        : {
            ...state.customerByCustomerId,
            [customer.customerId]: customer,
          },
    }),

    getSavedCardsRequest: (state, { payload: { customerId, cardIndex } }) => ({
      ...state,
      deleteCardStatus: SearchStatus.INITIAL,
      deleteCardError: '',
      getSavedCardsStatuses: {
        ...state.getSavedCardsStatuses,
        [customerId || '']: SearchStatus.SEARCHING,
      },
    }),
    getSavedCardsResponse: (state, { payload: { customerId, cards } }) => ({
      ...state,
      getSavedCardsStatuses: {
        ...state.getSavedCardsStatuses,
        [customerId || '']: SearchStatus.DONE,
      },
      savedCardsByCustomerId: {
        ...state.savedCardsByCustomerId,
        [customerId || '']: cards,
      },
    }),
    deleteCardRequest: (state, { payload }) => ({
      ...state,
      deleteCardStatus: {
        ...state.deleteCardStatus,
        [payload.card.id]: SearchStatus.SEARCHING,
      },
      deleteCardError: '',
      defaultCardError: '',
    }),
    deleteCardResponse: (state, { payload }) => ({
      ...state,
      deleteCardStatus: {
        ...state.deleteCardStatus,
        [payload.card.id]: SearchStatus.DONE,
      },
      deleteCardError: payload.error ? payload.error : '',
    }),
    setDefaultCardRequest: (state, { payload }) => ({
      ...state,
      setDefaultCardStatus: {
        ...state.setDefaultCardStatus,
        [payload.card.id]: SearchStatus.SEARCHING,
      },
      deleteCardError: '',
      defaultCardError: '',
    }),
    setDefaultCardResponse: (state, { payload }) => ({
      ...state,
      setDefaultCardStatus: {
        ...state.setDefaultCardStatus,
        [payload.card.id]: SearchStatus.DONE,
      },
      defaultCardError: payload.error ? payload.error : '',
    }),
  },
});

export const getCustomerInfoByCustomerId = (customerId) => (state) =>
  state.customer.customerByCustomerId && customerId
    ? state.customer.customerByCustomerId[customerId]
    : null;

export const getCustomerInfoStatus = (customerId) => (state) => {
  if (!customerId) return SearchStatus.INITIAL;
  if (state.customer.customerByCustomerId && state.customer.customerByCustomerId[customerId]) {
    return SearchStatus.DONE;
  }
  return SearchStatus.INITIAL;
};

export const {
  setSelectedCustomer,
  searchCustomerByEmailRequest,
  searchCustomerByEmailResponse,
  searchCustomersRequest,
  searchCustomersSuccess,
  getSavedCardsRequest,
  getSavedCardsResponse,
  deleteCardRequest,
  deleteCardResponse,
  setDefaultCardRequest,
  setDefaultCardResponse,
} = customerSlice.actions;

export default customerSlice.reducer;
